// src/hooks/useAuth.js - UPDATED to include employee type information
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext.js';

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};

// Optional: Export a custom hook for checking permissions
export const usePermissions = () => {
  const { currentUser } = useAuth();
  const { selectedCompany } = useContext(require('../contexts/CompanyContext.js').CompanyContext);
  
  // This would need to be expanded to include permission checking logic
  // For now, we'll keep the permission logic in the components that need it
  // since they already fetch the data
  
  return {
    isAdmin: currentUser?.isEmployee && currentUser?.employeeTypeId === 1,
    isCustomerService: currentUser?.isEmployee && currentUser?.employeeTypeId === 2,
  };
};